// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"b2373950","161":"cdce2f72","254":"b6a58bba","385":"0adb9853","399":"2f68fba2","693":"85c379f0"}[chunkId] + ".css";
};